import { IAutoCompletePrefix } from "api/interfaces/search.type";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import SearchBar from "component/searchBar/SearchBar";
import useScreenSize from "hoc/useScreenSize";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import {
  useCallback,
  useEffect,
  useState,
} from "react";
import { debounceWithCallAPI } from "util/lodash/debounceWithCallAPI";
import autocomplete from "util/search/autoComplete";
import { getDynamicUrlPrefixSearch } from "util/search/getDynamicUrlPrefixSearch";
import styles from "./styles.module.scss";

function OESearch() {
  const [responseAutoComplete, setResponseAutoComplete] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const router = useRouter();
  const { t } = useTranslation("category");

  const debounceOnSuggestionsFetchRequested = useCallback(
    debounceWithCallAPI(autocomplete, 0, setResponseAutoComplete, false),
    [],
  );

  const [isMobile] = useScreenSize();

  useEffect(() => {
    if (Array.isArray(responseAutoComplete)) {
      setSuggestions(responseAutoComplete);
    } else {
      setSuggestions([]);
    }
  }, [responseAutoComplete]);

  function handleSearchClick(suggestion: IAutoCompletePrefix) {
    getDynamicUrlPrefixSearch(suggestion, null, router);
  }

  return (
    <div className={styles.oe_search_container}>
      <PAText fontSize={isMobile ? FONT_SIZE[3] : FONT_SIZE[5]} color="black" className={styles.search_results_text}>
        {t("Search Results")}
      </PAText>
      <div className={styles.oe_searchbar}>
        <PAText component="span" className={styles.for_text} fontSize={FONT_SIZE[2]}>
          {t("for")}
        </PAText>
        <SearchBar
          absolutePosition
          searchClassName={styles.oe_search_input}
          searchValueHandler={debounceOnSuggestionsFetchRequested}
          results={suggestions}
          onClick={handleSearchClick}
          placeholder={router?.query?.oePartNumber}
          fullWidth
          hideHeading
        />
      </div>
    </div>
  );
}

export default OESearch;
